export default () => ({
  id: 'pregnant',
  label: 'Are you pregnant?',
  warn: 'yes',
});
